import { render, staticRenderFns } from "./capNhatTinNoiBo.vue?vue&type=template&id=69b145c6&"
import script from "./capNhatTinNoiBo.vue?vue&type=script&lang=js&"
export * from "./capNhatTinNoiBo.vue?vue&type=script&lang=js&"
import style0 from "./capNhatTinNoiBo.vue?vue&type=style&index=0&id=69b145c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports